/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const POPPER_POSITIONS = {
  "top-start": "top-start",
  top: "top",
  "top-end": "top-end",
  "right-start": "right-start",
  right: "right",
  "right-end": "right-end",
  "bottom-start": "bottom-start",
  bottom: "bottom",
  "bottom-end": "bottom-end",
  "left-start": "left-start",
  left: "left",
  "left-end": "left-end",
};

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
type PopperPositionType = keyof typeof POPPER_POSITIONS;

export type { PopperPositionType };
export { POPPER_POSITIONS };
